export default {
    namespaced: true,
    state: {
        vorname: null,
        nachname: null,
        telefonnummer: null,
        eMail: null
    },
    getters: {
        vorname (state) {
            return state.vorname
        },
        nachname (state) {
            return state.nachname
        },
        telefonnummer (state) {
            return state.telefonnummer
        },
        eMail (state) {
            return state.eMail
        }
    },
    mutations: {
        vorname (state, vorname) {
            state.vorname = vorname
        },
        nachname (state, nachname) {
            state.nachname = nachname
        },
        telefonnummer (state, telefonnummer) {
            state.telefonnummer = telefonnummer
        },
        eMail (state, eMail) {
            state.eMail = eMail
        },
        reset (state) {
            state.vorname = null
            state.nachname = null
            state.telefonnummer = null
            state.eMail = null
        }
    },
    actions: {

    }
}
